// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f529d547","453":"61e00712","796":"f7e1cb76"}[chunkId] + ".chunk.js";
};